module.exports = __webpack_public_path__ + "img/substitution_small.63efb0ac.svg";